'use strict';

import angular from 'angular';
import FormController from 'app/controllers/form';

class RegistryController extends FormController {
    /* @ngInject */
    constructor(
        RegistriesService,
        $scope,
        $mdDialog,
        $mdToast,
        $state,
        $location
    ) {
        let registry = $scope.$parent.$resolve.registry;
        super(
            registry,
            'Registro',
            RegistriesService,
            null,
            'registries'
        );

        Object.assign(this, {
            RegistriesService,
            $mdDialog,
            $mdToast,
            $state,
            $location
        });
    }

    $onInit() {
        super.$onInit();
    }
}

export default RegistryController;
